import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  browserSessionPersistence,
  setPersistence,
  signInWithPopup,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase config (deze verkrijg je uit het Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyBrlUHMtDz-Cq9XnAMWiOGZlE9htHIlw10",
  authDomain: "webportaal.firebaseapp.com",
  projectId: "webportaal",
  storageBucket: "webportaal.firebasestorage.app",
  messagingSenderId: "517315571546",
  appId: "1:517315571546:web:0773de68b0d3fcddf70d63",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "select_account",
  hd: "zuidzorg.nl",
});

export {
  auth,
  db,
  provider,
  browserSessionPersistence,
  setPersistence,
  signInWithPopup,
};
